/// <amd-module name="Analytics/Queries/ProjectsQuery" />
import { AnalyticsCacheableQueryBase, CommonFeatureCommandName } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

/** Basic Project info */
export interface ProjectIdentity {
    ProjectId: string;
    ProjectName: string;
}

/**
 * Gets a list of projects.
 */
export class ProjectsQuery extends AnalyticsCacheableQueryBase<ProjectIdentity[]> {
    private static generateQueryOptions(): ODataQueryOptions {
        return {
            entityType: "Projects",
            oDataVersion: latestODataVersion,
            $orderby: "ProjectName",
            $select: "ProjectId,ProjectName"
        };
    }

    /** Runs an unfiltered query for all projects at the collection level. */
    public static onCollection() {
        return new ProjectsQuery();
    }
    protected constructor() {
        super(CommonFeatureCommandName, ProjectsQuery.generateQueryOptions());
    }

    public getQueryName(): string {
        return "ProjectsQuery";
    }
}
